import QuickFilter from "../../Common/QuickFilter";

const ShipperQuickFilter = (props) => {
  return <QuickFilter key={props.filterName} {...props} />;
};

export default ShipperQuickFilter;
